import {useContext, useEffect, useState} from 'react';
import {CartContext} from '../../api/context';
import {Collapse, Grid, TextField} from '@mui/material';
import {CartDTO} from '../../api/models';
import {isAddressValid, isEmailValid, isMobileNumberValid, isNameValid} from '../../common/utils';
import {TextComponent} from '../RetailerWebScreen/components/TextComponent';
import {CartIssues} from './components/CartIssues';
import {CartPaymentDetails} from './components/CartPaymentDetails';
import {FetchCartItemDetailsButton} from './components/FetchCartItemDetailsButton';
import {CartItemDetailsView} from './components/CartItemDetailsView';
import {useEventBatching} from '../../api/events';

export const ReviewCartDetailScreen = () => {
    const [customerName, setCustomerName] = useState<string | undefined>();
    const [customerEmail, setCustomerEmail] = useState<string | undefined>();
    const [customerMobileNumber, setCustomerMobileNumber] = useState<string | undefined>();
    const [customerAddress, setCustomerAddress] = useState<string | undefined>();

    const [cartDTO, setCartDTO] = useState<CartDTO | undefined>();
    const [showPayments, setShowPayments] = useState<boolean>(false);
    const [showCartItemDetails, setShowCartItemDetails] = useState<boolean>(true);
    const {trackEvent} = useEventBatching();

    useEffect(() => {
        if (cartDTO) {
            if (cartDTO.violations.length !== 0) {
                setShowPayments(false);
                setShowCartItemDetails(true);
            } else if (cartDTO.paymentDetails.finalAmount < 100) {
                alert('Payment information received is invalid, please try again later.');
                setShowPayments(false);
                setShowCartItemDetails(true);
            } else {
                setShowPayments(true);
                setShowCartItemDetails(false);
            }
            trackEvent({
                eventName: 'Fetch Cart: Details',
                props: {
                    cartDTO: JSON.stringify(cartDTO),
                },
            });
        }
    }, [cartDTO]);

    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const context = useContext(CartContext);

    useEffect(() => {
        const validateBuyerDTO = () => {
            const isValidName = isNameValid(customerName);
            const isValidEmail = isEmailValid(customerEmail);
            const isValidAddress = isAddressValid(customerAddress);
            const isValidNumber = isMobileNumberValid(customerMobileNumber);
            const isValid = isValidName && isValidEmail && isValidAddress && isValidNumber;
            setIsButtonDisabled(!isValid);
        };

        validateBuyerDTO();
    }, [customerName, customerEmail, customerMobileNumber, customerAddress]);

    return (
        <div
            style={{
                paddingLeft: 24,
                paddingRight: 24,
                paddingTop: 32,
                paddingBottom: 24,
            }}>
            <Grid style={{marginTop: 12}} container>
                <Grid item md={12} xs={12} sm={12}>
                    <TextComponent variant='h5' content={'Customer Details'} fontWeight={600} />
                </Grid>
            </Grid>
            <Grid style={{marginTop: 12}} container>
                <Grid item md={12} xs={12} sm={12}>
                    <TextField
                        style={{
                            color: 'black',
                        }}
                        id={'customer-name'}
                        label='Name'
                        variant='outlined'
                        fullWidth
                        value={customerName}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setCustomerName(e.target.value);
                        }}
                    />
                    <br />
                    <br />
                    <TextField
                        style={{
                            color: 'black',
                        }}
                        id={'customer-email'}
                        label='Email'
                        variant='outlined'
                        fullWidth
                        value={customerEmail}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setCustomerEmail(e.target.value);
                        }}
                    />
                    <br />
                    <br />
                    <TextField
                        style={{
                            color: 'black',
                        }}
                        id={'customer-mobile-num'}
                        label='Mobile Number'
                        variant='outlined'
                        fullWidth
                        value={customerMobileNumber}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setCustomerMobileNumber(e.target.value);
                        }}
                    />
                    <br />
                    <br />
                    <TextField
                        style={{
                            color: 'black',
                        }}
                        id={'customer-address'}
                        label='Address'
                        variant='outlined'
                        fullWidth
                        value={customerAddress}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            setCustomerAddress(e.target.value);
                        }}
                    />
                </Grid>
            </Grid>
            <br />
            <CartIssues cartDTO={cartDTO} />
            <br />
            <Collapse in={showPayments}>{cartDTO ? <CartPaymentDetails cartDTO={cartDTO} /> : <></>}</Collapse>
            <Collapse in={showCartItemDetails}>
                <CartItemDetailsView />
                <FetchCartItemDetailsButton
                    currCartItems={Array.from(context?.getCart()?.cartItems.values() ?? [])}
                    isButtonDisabled={isButtonDisabled}
                    websiteId={context?.getWebsiteId()}
                    buyerDTO={{
                        name: customerName!!,
                        email: customerEmail!!,
                        mobileNumber: customerMobileNumber!!,
                        address: customerAddress!!,
                    }}
                    setCartDTO={(updatedCartDTO: CartDTO) => setCartDTO(updatedCartDTO)}
                />
            </Collapse>
        </div>
    );
};
